import { render } from "./indexsixcenter.vue?vue&type=template&id=4aa70cd2"
import script from "./indexsixcenter.vue?vue&type=script&lang=js"
export * from "./indexsixcenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__